<template>
<section v-if="data.length" class="home-page-people">
    <div class="home-page-people__body">
        <z-caption
            tag="h2"
            size="xl"
            class="u-bottom-margin--xl-important"
            theme="white"
            :href="`/${$root.lang}/career/team/`"
            uppercase
        >
            <span v-html="text.title"></span>
        </z-caption>
        <slider class="home-page-people__slider" autoplay loop>
            <slide v-for="(item, index) in data" :key="index">
                <z-blockquote
                    size="l"
                    :author="{
                        name: item.name,
                        info: item.position.value,
                        photo: item.previewPicture.link
                    }"
                    :text="item.quote.value"
                    :date="item.activeFrom ? $options.filters.momentFilter(item.activeFrom, 'DD MMMM YYYY') : ''"
                >
                    <template #footer>
                        <div class="home-page-people__links">
                            <z-link size="l" :href="item.detailPageUrl" internal>
                                <span v-html="text.historyOfSuccess"></span>
                            </z-link>
                            <z-link size="l" :href="`/${$root.lang}/career/why-raspadskaya/`" internal>
                                <span v-html="text.whyRasp"></span>
                            </z-link>
                        </div>
                    </template>
                </z-blockquote>
            </slide>
        </slider>
    </div>
</section>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'people',
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            text: {
                title: localize({
                    ru: 'Люди распадской',
                    en: 'Our people'
                }),
                historyOfSuccess: localize({
                    ru: 'История сотрудника',
                    en: 'Employee history'
                }),
                whyRasp: localize({
                    ru: 'Почему Распадская?',
                    en: 'Why Raspadskaya?'
                })
            }
        }
    }
}
</script>

<style lang="scss">
.home-page-people {
    margin-left: -5px;

    @include breakpoint (v-tablet) {
        padding: 0 20px;
    }

    &__body {
        padding: $token-spacers-2-xl $token-spacers-3-xl;
        background-image: url(/images/main-page/people-bg.jpg);
        background-repeat: no-repeat;
        background-size: cover;

        @include breakpoint(v-tablet) {
            padding: 0;
            background: none;
        }

        .z-caption {
            span {
                @include breakpoint(v-tablet) {
                    color: $token-colors-black-80;
                }
            }
        }
    }

    @include breakpoint (v-tablet) {
        .z-blockquote {
            blockquote {
                @include typo-level(M)
            }
        }
    }

    @media (min-width: 1023px) {
        .z-blockquote {
            blockquote {
                color: #fff;
            }

            &__name {
                color: #EF7812;
            }

            &__info,
            &__date,
            &__footer-divider:before {
                color: #D5D5D9;
            }
        }

        &__slider {
            .slider__controls {
                padding-left: calc(350px + #{$token-spacers-m});
            }

            .swiper-pagination-bullet {
                background: $token-colors-white;
                opacity: 0.7;
            }

            .swiper-pagination-bullet-active {
                opacity: 1;
            }

            .slider__nav-btn {
                .z-icon path {
                    fill: $token-colors-white;
                }
            }
        }

        &__links {
            .z-link {
                color: $token-colors-white;
            }
        }
    }

    &__links {
        @include margin-level(top, XL);
        @include margin-level(bottom, 2XL);

        .z-link {
            @include margin-level(right, 2XL);

        }
    }
}

</style>
